import { Component } from '@angular/core';
import { NavController, NavParams} from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { ProductoPage } from '../producto/producto';

/**
 * Generated class for the BusquedaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-busqueda',
  templateUrl: 'busqueda.html',
})
export class BusquedaPage {
  busqueda: any = ''
  loading: any = false
  timeout: any = ''
  productos: any = []
  url = this.http.images
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public http: HttpProvider
    ) {
  }

  ir(item){
    this.navCtrl.push(ProductoPage,{producto:item})
  }

  buscar(){
    if(this.busqueda.length > 1){
      this.loading = true
      clearTimeout(this.timeout)
      this.timeout = setTimeout(
        ()=>{
          this.http.get('productos/search/'+this.busqueda).subscribe(
            (res:any)=>{
              this.loading = false
              this.productos = res
            },
            error=>console.log(error)
          )   
        },
        3000
      )
    }else{
      this.loading = false
      this.productos = []
    }
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/busqueda/busqueda.ts